import {  createSlice } from "@reduxjs/toolkit";
import { Nullable } from "../../../Types/Common";
import { checkUserDetailsService } from "../../../Api/Services/CheckUserDetailsService";
import createServiceAsyncThunk from "../../../utils/reduxUtils/createServiceAsyncThunk";

export interface ICheckUserDetailsInitialState {
  loading: boolean;
  error: Nullable<string>;
  checkDetailsUser: Nullable<any>;
}

const checkUserDetailsInitialState: ICheckUserDetailsInitialState = {
  loading: false,
  error: null,
  checkDetailsUser: null,
};

export const checkUserDetails = createServiceAsyncThunk<
  any,
  { userId: string }
>(
  "/fetch/checkUserDetails",
  ({ userId }) => checkUserDetailsService.checkUserDetails(userId),
  "Failed to check user details"
);

const checkUserDetailsSlice = createSlice({
  name: "checkUserDetails",
  initialState: checkUserDetailsInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(checkUserDetails.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(checkUserDetails.fulfilled, (state, action) => {
      state.checkDetailsUser = action.payload;
      state.loading = false;
    });
    builder.addCase(checkUserDetails.rejected, (state, action: any) => {
      state.error = action.payload;
      state.loading = false;
    });
  },
});

export default checkUserDetailsSlice.reducer;
